import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import SortableTable from "../../../Componentes/Utils/SortableTable";
import useApi from "../../../hooks/useApi";

const PAGE_SIZE = 100;
const SCROLL_THRESHOLD = 40;

const PageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
    overflow: hidden;
`;

const TableFlexFill = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    flex-direction: column;

    & > div {
        flex: 1;
        min-height: 0;
        display: flex;
        flex-direction: column;
    }
`;

const Content = () => {
    const api = useApi();
    const tableRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [colaboradores, setColaboradores] = useState([]);
    const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

    useEffect(() => {
        const fetchColaboradores = async () => {
            setLoading(true);

            try {
                const { data } = await api.get("/Painel/API/Almoxarifado/Colaboradores/index.php");
                setColaboradores(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error(error);
                setColaboradores([]);
            } finally {
                setLoading(false);
            }
        };

        fetchColaboradores();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setVisibleCount(PAGE_SIZE);
        if (tableRef.current) {
            tableRef.current.scrollTop = 0;
        }
    }, [colaboradores]);

    const loadMoreRows = useCallback(() => {
        setVisibleCount((prev) => {
            const total = colaboradores.length;
            if (prev >= total) return prev;
            return Math.min(prev + PAGE_SIZE, total);
        });
    }, [colaboradores.length]);

    const columns = useMemo(
        () => [
            {
                id: "matricula",
                header: "MATRÍCULA",
                accessor: "matricula",
                sortable: true,
                width: "110px",
            },
            {
                id: "nome",
                header: "NOME",
                accessor: "nome",
                sortable: true,
            },
            {
                id: "funcao",
                header: "FUNÇÃO",
                accessor: "funcao",
                sortable: true,
            },
            {
                id: "lider",
                header: "LÍDER",
                accessor: "lider",
                sortable: true,
                render: (value) => value || "-",
            },
            {
                id: "centro_custo",
                header: "CENTRO DE CUSTO",
                accessor: "centro_custo",
                sortable: true,
            },
            {
                id: "contrato",
                header: "CONTRATO",
                accessor: "contrato",
                sortable: true,
                render: (value) => value || "-",
            },
            {
                id: "mao_obra",
                header: "MÃO DE OBRA",
                accessor: "mao_obra",
                sortable: true,
                width: "130px",
                render: (value) => value || "-",
            },
            {
                id: "status",
                header: "STATUS",
                accessor: "status",
                sortable: true,
                width: "100px",
            },
        ],
        []
    );

    return (
        <PageContent>
            <TableFlexFill>
                <SortableTable
                    ref={tableRef}
                    columns={columns}
                    data={colaboradores}
                    getRowId={(row) => row.matricula}
                    isLoading={loading}
                    loadingText="Carregando colaboradores..."
                    emptyText="NENHUM COLABORADOR ENCONTRADO"
                    initialSort={{ key: "nome", direction: "asc" }}
                    limit={visibleCount}
                    onScrollReachEnd={loadMoreRows}
                    scrollReachThreshold={SCROLL_THRESHOLD}
                />
            </TableFlexFill>
        </PageContent>
    );
};

export default Content;
